import { useState } from 'react'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'

const CollapsibleSection = ({
  title,
  children,
  defaultExpanded = false,
  statusElement = null,
  description = null,
  className = '',
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)

  const handleToggle = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <div className={`bg-neutral-200-50 border rounded-lg p-4 ${className}`}>
      <div className="flex items-center justify-between mb-2 cursor-pointer" onClick={handleToggle}>
        <div className="flex items-center gap-2">
          <h4 className="font-semibold">{title}</h4>
          {isExpanded ? (
            <ChevronUpIcon className="w-4 h-4 text-gray-500" />
          ) : (
            <ChevronDownIcon className="w-4 h-4 text-gray-500" />
          )}
        </div>
        {statusElement && <span className="text-sm flex gap-1">{statusElement}</span>}
      </div>

      {description && <p className="text-sm text-gray-600 mb-2">{description}</p>}

      {isExpanded && children}
    </div>
  )
}

export default CollapsibleSection
